import { API_BASE_URL, getHeaders } from './config'

export async function fetchEnablementResources() {
  const response = await fetch(`${API_BASE_URL}/enablement/resources`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch enablement resources')
  }
  
  return response.json()
}

export async function fetchEnablementProgress() {
  const response = await fetch(`${API_BASE_URL}/enablement/progress`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch enablement progress')
  }
  
  return response.json()
}

export async function completeResource(resourceId: string) {
  const response = await fetch(`${API_BASE_URL}/enablement/complete/${resourceId}`, {
    method: 'POST',
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to complete resource')
  }
  
  return response.json()
}

export async function uncompleteResource(resourceId: string) {
  const response = await fetch(`${API_BASE_URL}/enablement/complete/${resourceId}`, {
    method: 'DELETE',
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to uncomplete resource')
  }
  
  return response.json()
}
